module.exports = __webpack_public_path__ + "static/media/intersystems.730aab1a.png";